"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePerson = usePerson;
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const view_models_1 = require("../../view-models/index.js");
function usePerson(id) {
    const persons = (0, stores_1.useCalculatorStore)((state) => state.data.persons);
    const baseUrl = (0, stores_1.useCalculatorStore)((state) => state.baseUrl);
    return (0, react_1.useMemo)(() => {
        const person = persons?.find((person) => person.id === id);
        return person ? (0, view_models_1.personViewModel)(person, baseUrl) : undefined;
    }, [persons, id, baseUrl]);
}
